// @ts-nocheck
import _, { isArray, isNull, isUndefined } from "lodash";
import {
  createEstimateConfigAction,
  halfDayEventClickAction,
  halfDayPosiitonClickAction,
  overridePosiitonClickAction,
  postPositionTermsAction,
  updateEstimateConfigAction,
  updatePositionsForCaliforniaContratorForEvent
} from "../../../store/actions/eventRequestDetails";
import { DEFAULT_ESTIMATE_NAME } from "../../constants/nmaes";
import {
  getBreaks,
  getBreaksEstimate,
  getDescriptionThoughHoursIdxInvoice,
  getRateThoughHoursIdx,
  getTimeDiff,
  getTimeDiffOfPositionsOnlyNumberOfHours,
  isTimeTBD
} from "../calculations";
import { formatNumber, getSanitizedFileName } from "../formatters";

import {
  getUniversalDateTimeFormat,
  getUniversalDateWithTimeFormat
} from "../universalDateTimeFormat";
import dayjs from "dayjs";
import { getCssVariableHandler } from "../../styles/getCssVariables";
import { isUserRole, isActiveRole } from "../storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import { getFullTimeEstimate } from "../calcUtils";
import {
  convertFromUTCToGivenTimezone,
  formatAMPM
} from "../dateAndTimeMethods";
import { downloadCSV } from "../other/generateCsv";
import { PositionTerms } from "../../../components/Estimate/PositionTerms";
import {
  getCaliforniaContractorRate,
  getUTCTimeDifferenceWithDate,
  calcEstimateForInvoice,
  checkValidValue
} from "../../../appCalcutions";
import { postAppliedContractorRateAction } from "../../../store/actions/estimate";

export const HALF_DAY_INCREMENTED_RATE = 3;
export const DEPOSIT_AMOUNT = 0.5;

export const getCurrentStatusOfEstimate = (estimate) => {
  const isSubmit = estimate?.isEstimateSubmitted;
  const isReject = estimate?.isEstimateRejected;
  const isApprove = estimate?.isEstimateApproved;
  const isRevised = estimate?.isEstimateRevised;
  if (isSubmit && !isReject && !isApprove)
    return isActiveRole(USER_ROLES.CLIENT)
      ? isRevised
        ? "Revised Estimate Approval Pending"
        : "Estimate Approval Pending"
      : isRevised
        ? "Revised Estimate Sent To Client"
        : "Estimate Sent To Client";
  if (isSubmit && isReject && !isApprove)
    return isRevised ? "Revised Estimate Rejected" : "Estimate Rejected";
  if (isSubmit && !isReject && isApprove)
    return isRevised ? "Revised Estimate Approved" : "Estimate Approved";
  return null;
};

export const getEstimateButtonText = (estimate) => {
  const isSubmit = estimate?.isEstimateSubmitted;
  const isReject = estimate?.isEstimateRejected;
  const isApprove = estimate?.isEstimateApproved;
  const isRevised = estimate?.isEstimateRevised;

  if (isSubmit && !isReject && !isApprove)
    return isActiveRole(USER_ROLES.CLIENT)
      ? "Click here to Approve"
      : isApprove
        ? "Share Revised Estimate"
        : "Share Revised Estimate";
  if (isSubmit && isReject && !isApprove)
    return isActiveRole(USER_ROLES.CLIENT)
      ? null
      : isApprove
        ? "Share Revised Estimate"
        : "Share Revised Estimate";
  if (isSubmit && !isReject && isApprove)
    return isActiveRole(USER_ROLES.CLIENT)
      ? "The Estimate has been approved."
      : isApprove
        ? "Share Revised Estimate"
        : "Share Revised Estimate";
  return isUserRole(USER_ROLES?.CLIENT) ? null : "Share With Client";
};

export const getCurrentStatusOfSubmittedEstimate = (estimate) => {
  const isSubmit = estimate?.isEstimateSubmitted;
  const isApprove = estimate?.isEstimateApproved;

  if (isApprove) return "Approved";
  if (isSubmit) return "Sent";
  return "-";
};

export const isEstimateButtonDisableForClient = (estimate) => {
  const isSubmit = estimate?.isEstimateSubmitted;
  const isReject = estimate?.isEstimateRejected;
  const isApprove = estimate?.isEstimateApproved;

  if (isSubmit && !isReject && !isApprove) return false;
  return true;
};

export const isEstimateConfigForSubmit = (estimate) => {
  const isSubmit = estimate?.isEstimateSubmitted;

  if (!isSubmit) return true;
  else return false;
};

export const isEstimateConfigForApprove = (estimate) => {
  const isSubmit = estimate?.isEstimateSubmitted;
  const isReject = estimate?.isEstimateRejected;
  const isApprove = estimate?.isEstimateApproved;

  if (isSubmit && !isReject && !isApprove) return true;
  else return false;
};

export const isCurrentEstimateSubmitted = (estimate) => {
  return estimate?.isEstimateSubmitted;
};

export const getCurrentStatusColorOfEstimate = (estimate) => {
  const isSubmit = estimate?.isEstimateSubmitted;
  const isReject = estimate?.isEstimateRejected;
  const isApprove = estimate?.isEstimateApproved;

  if (isSubmit && !isReject && !isApprove)
    return { color: "#cda80c", bg: "#cda80c99" };
  if (isSubmit && isReject && !isApprove)
    return { bg: "#e539358a", color: "#e53935" };
  if (isSubmit && !isReject && isApprove)
    return { bg: "#0774508a", color: "#077450" };
  return {
    bg: getCssVariableHandler({ variableName: "--primary-pink-hex" }),
    color: getCssVariableHandler({ variableName: "--primary-pink-hex" })
  };
};

/**
 * Why an estimate PDF cannot be generated for the selected configuration, or
 * `null` when it can. Shared by the "printer" button and the Position List
 * button so both surfaces block the same way instead of posting an undefined
 * `configurationId` to the pdf-service (which answers 400
 * "configurationId is required when estimateId is absent" — the raw message
 * the client saw on 2027 ASHRAE, 02/09/2026).
 */
export const getEstimatePdfBlockReason = ({ eventInfo, configuration }) => {
  if (configuration?._id) return null;
  if (eventInfo && eventInfo.submitted === false) {
    return "This event is still a saved draft. Submit the event before generating its estimate PDF.";
  }
  return "There is no estimate for this event yet. Add sessions and open the Estimate tab to create one.";
};

export const createEstimateConfigs = ({
  sessions,
  dispatch,
  config,
  eventId,
  eventSubmitted
}) => {
  if (isNull(config)) return;
  // Drafts (`event.submitted === false`) are invisible to
  // `getSubmittedConfiguredEstimate` (BE filters `submitted:true`), so an empty
  // `config` is NOT evidence that the master is missing. Creating it here would
  // push a new "Event Estimate" on every mount — 2027 ASHRAE got 3 masters in
  // two minutes (02/09/2026). The master is created once the event is submitted.
  if (eventSubmitted === false) return;
  const eventEstimate = config?.find(
    (item) => item?.estimateName === DEFAULT_ESTIMATE_NAME
  );
  if (!eventEstimate) {
    const allSessionIds = sessions?.map((item) => item?._id);
    const params = {
      eventId
    };
    const payload = {
      estimateName: DEFAULT_ESTIMATE_NAME,
      isMasterConfig: true,
      sessionIds: allSessionIds
    };

    const sessionPoNumbers = {};
    sessions?.forEach((item) => {
      if (item?.poNumber) {
        if (isArray(sessionPoNumbers[item?.poNumber])) {
          sessionPoNumbers[item?.poNumber]?.push(item?._id);
        } else {
          sessionPoNumbers[item?.poNumber] = [item?._id];
        }
      }
    });
    dispatch(
      createEstimateConfigAction({
        payload: {
          params,
          data: payload,
          stopRefresh: Object.keys(sessionPoNumbers)?.length == 0 ? false : true
        }
      })
    );

    Object.entries(sessionPoNumbers)?.forEach(([key, value], index) => {
      const data = {
        estimateName: key,
        sessionIds: value
      };
      dispatch(
        createEstimateConfigAction({
          payload: {
            params,
            data,
            stopRefresh: Object.keys(sessionPoNumbers)?.length - 1 !== index
          }
        })
      );
    });
  } else {
    const allSessionIds = sessions?.map((item) => item?._id);
    if (_.isEqual(_.sortBy(allSessionIds), _.sortBy(eventEstimate?.sessionId)))
      return;
    const params = { eventId, configurationId: eventEstimate?._id };
    const payload = {
      estimateName: DEFAULT_ESTIMATE_NAME,
      sessionIds: allSessionIds
    };
    dispatch(
      updateEstimateConfigAction({
        payload: {
          params,
          data: payload
        }
      })
    );
  }
};

/**
 * @param { Object } positons
 * @returns { Array } - array of positions who have less than 6 hours working time
 */
export function getPositionIdsOfLessThan6Hours({
  positions,
  eventInfo,
  terms
}) {
  return _.flatMap(positions, (posArr) =>
    posArr.filter(
      (p) =>
        getTimeDiffOfPositionsOnlyNumberOfHours({ pos: p, eventInfo, terms }) <=
        terms?.halfDay + 1
    )
  );
}

export function getPositionsOfHalfDayHours({ positions }) {
  return _.flatMap(positions, (posArr) =>
    posArr.filter((p) => p?.isHalfdayHours)
  );
}

export function getPositionsOfClientHalfDayHours({ positions }) {
  return _.flatMap(positions, (posArr) =>
    posArr.filter((p) => p?.isHalfdayHours)
  );
}

export function halfDayClickForEventHandler({
  value,
  positions,
  eventInfo,
  dispatch,
  terms,
  incDecValue,
  onlyPositions = false, // only when we want to update the values not half day hours
  oldEventTerms = {},
  ignoreGlobal = false,
  newPositionTerms,
  successCallback = () => {}
}) {
  const list = !value
    ? getPositionsOfHalfDayHours({ positions })
    : getPositionIdsOfLessThan6Hours({
        positions,
        eventInfo,
        terms
      });

  if (!newPositionTerms) {
    newPositionTerms = terms;
  }

  const ids = list
    ?.map((item) => {
      let isGlobal = true;
      isGlobal =
        isUndefined(item?.positionTerms) ||
        (!isUndefined(item?.positionTerms) &&
          getShortTermsString(item, {
            eventTerms: oldEventTerms
          })?.toLowerCase() == "global");

      const appRate = Number(
        checkValidValue({ value: item?.estimateAppliedRate })
          ? item?.estimateAppliedRate
          : item?.positionData?.defaultRate
      );

      if (ignoreGlobal) {
        isGlobal = true;
      }
      if (!isGlobal) {
        return null;
      }
      return {
        id: item?._id,
        isHalfdayHours:
          isGlobal && !onlyPositions ? value : item?.isHalfdayHours,
        isHalfDayManualOverride: item?.isHalfDayManualOverride,
        estimateAppliedRate: !isGlobal
          ? appRate
          : value
            ? appRate +
              (isUndefined(incDecValue)
                ? HALF_DAY_INCREMENTED_RATE
                : incDecValue)
            : appRate -
              (isUndefined(incDecValue)
                ? HALF_DAY_INCREMENTED_RATE
                : incDecValue)
      };
    })
    ?.filter((i) => !!i);

  const validPositions = ids?.map((item) => item?.id);

  dispatch(
    halfDayEventClickAction({
      payload: { data: { ids }, status: !onlyPositions ? value : undefined },
      successCallback: () => {
        successCallback(ids);
      }
    })
  );

  const positionIds = list
    ?.map((item) => {
      if (!validPositions?.includes(item?._id)) return null;
      return {
        id: item?._id,
        timeIn: item?.timeIn,
        timeOut: item?.timeOut,
        numberOfHours: item?.numberOfHours,
        positionTerms: {
          ...item?.positionTerms,
          halfDay: !isUndefined(item?.positionTerms?.halfDayHours)
            ? item?.positionTerms?.halfDayHours
            : newPositionTerms?.halfDayHours || newPositionTerms?.halfDay,
          fullDay: !isUndefined(item?.positionTerms?.fullDayHours)
            ? item?.positionTerms?.fullDayHours
            : newPositionTerms?.fullDayHours || newPositionTerms?.fullDay,
          overTime: !isUndefined(item?.positionTerms?.overTimeHours)
            ? item?.positionTerms?.overTimeHours
            : newPositionTerms?.overTimeHours || newPositionTerms?.overTime,
          contractorHourlyRate: !isUndefined(
            item?.positionTerms?.contractorHourlyRate
          )
            ? item?.positionTerms?.contractorHourlyRate
            : newPositionTerms?.contractorHourlyRate,
          clientHourlyRate: !isUndefined(item?.positionTerms?.clientHourlyRate)
            ? item?.positionTerms?.clientHourlyRate
            : newPositionTerms?.clientHourlyRate,
          clientHalfDayInc: isUndefined(newPositionTerms?.clientHalfDayInc)
            ? item?.positionTerms?.clientHalfDayInc || false
            : newPositionTerms?.clientHalfDayInc,
          contractorHalfDayInc: isUndefined(
            newPositionTerms?.contractorHalfDayInc
          )
            ? item?.positionTerms?.contractorHalfDayInc || false
            : newPositionTerms?.contractorHalfDayInc
        },
        updatedContractorRate: item?.updatedContractorRate,
        positionData: {
          contractorRate: item?.positionData?.contractorRate
        },
        session: {
          _id: item?.session?._id
        }
      };
    })
    ?.filter((i) => i);

  let positionList = {};
  positionIds?.forEach((item) => {
    positionList[item?.id] = item?.positionTerms;
  });

  dispatch(
    postPositionTermsAction({
      payload: {
        params: {
          eventId: eventInfo?._id
        },
        data: {
          positionIds
        },
        positions: positionList
      }
    })
  );

  // check and update if necessary
  checkAndUpdateContractorCARateIfNecessary({
    eventTerms: oldEventTerms,
    rows: positionIds?.map((item) => ({ ...item, _id: item?.id })),
    eventId: eventInfo?._id,
    dispatch
  });
}

/**
 * function to check and update the ca rate if necessary
 */
export function checkAndUpdateContractorCARateIfNecessary({
  positionTerms,
  eventTerms,
  rows,
  eventId,
  dispatch
}) {
  if (!eventTerms?.californiaContractorPO_SOW) return;
  const ignoreList = getNotEligiblePositionsForCACaliforniaRate({
    positions: rows?.map((item) => ({
      ...item,
      positionTerms: positionTerms || item?.positionTerms || eventTerms
    }))
  });

  const params = {
    eventId
  };
  const fieldsToUpdate = rows
    ?.map((item) => {
      const conRate = checkValidValue({ value: item?.updatedContractorRate })
        ? item?.updatedContractorRate
        : item?.positionData?.contractorRate;
      return {
        id: item?._id,
        sessionId: item?.session?._id,
        californiaContractorRate: eventTerms?.californiaContractorPO_SOW
          ? ignoreList?.includes(item?._id)
            ? conRate
            : getCaliforniaContractorRate(conRate)
          : null
      };
    })
    ?.filter((i) => i?.id);

  const data = {
    fieldsToUpdate
  };

  dispatch(
    updatePositionsForCaliforniaContratorForEvent({
      payload: {
        params,
        data
      }
    })
  );
}

/**
 * function to get list of position not eligible
 * this returns a list of the positons which will have contractor rate same as ca rate
 */
export function getNotEligiblePositionsForCACaliforniaRate({ positions }) {
  let list = [];

  positions?.forEach((pos) => {
    let timeDiff = 0;
    if (isTimeTBD(pos?.timeIn) || isTimeTBD(pos?.timeOut)) {
      timeDiff = pos?.numberOfHours;
    } else {
      timeDiff = getUTCTimeDifferenceWithDate(pos?.timeIn, pos?.timeOut);
      if (pos?.firstBreak && pos?.afterFirstBreakIn) {
        timeDiff -= 1;
      }
    }
    if (
      pos?.positionTerms?.contractorHalfDayInc ||
      pos?.positionTerms?.contractorHourlyRate ||
      timeDiff <= 5
    ) {
      if (
        !pos?.positionTerms?.contractorHalfDayInc &&
        !pos?.positionTerms?.contractorHourlyRate &&
        (pos?.positionData?.isFullDay ?? pos?.isFullDay)
      ) {
        // do nothing
      } else {
        list.push(pos?._id);
      }
    }
  });
  return list;
}

/**
 * function to run after enabling terms for californiaContractorPO_SOW
 */
export function updateCaliforniaContractorRateSOW_PO({
  value,
  positions,
  eventInfo,
  dispatch
}) {
  const list = _.flatMap(Object.values(positions));

  const ignoreList = getNotEligiblePositionsForCACaliforniaRate({
    positions: list?.map((p) => ({
      ...p,
      positionTerms: p?.positionTerms || eventInfo?.terms
    }))
  });

  const params = {
    eventId: eventInfo?._id
  };
  const fieldsToUpdate = list
    ?.map((item) => {
      const conRate = checkValidValue({ value: item?.updatedContractorRate })
        ? item?.updatedContractorRate
        : item?.positionData?.contractorRate;
      return {
        id: item?._id,
        sessionId: item?.session?._id,
        californiaContractorRate: value
          ? ignoreList?.includes(item?._id)
            ? conRate
            : getCaliforniaContractorRate(conRate)
          : null
      };
    })
    ?.filter((i) => i?.id);

  const data = {
    fieldsToUpdate
  };

  dispatch(
    updatePositionsForCaliforniaContratorForEvent({
      payload: {
        params,
        data
      }
    })
  );
}

export function halfDayClickForPositionHandler({
  value,
  positions,
  dispatch,
  incDecValue,
  cb,
  onlyRate = false
}) {
  const appRate = Number(
    checkValidValue({ value: positions?.[0]?.estimateAppliedRate })
      ? positions?.[0]?.estimateAppliedRate
      : positions?.[0]?.positionData?.defaultRate
  );
  const ids = positions?.map((pos) => ({
    id: pos?._id,
    isHalfdayHours: !onlyRate ? value : pos?.isHalfdayHours,
    isHalfDayManualOverride: false,
    estimateAppliedRate: value
      ? appRate +
        (!isUndefined(incDecValue) ? incDecValue : HALF_DAY_INCREMENTED_RATE)
      : appRate -
        (!isUndefined(incDecValue) ? incDecValue : HALF_DAY_INCREMENTED_RATE)
  }));

  dispatch(
    halfDayPosiitonClickAction({
      payload: { data: { ids }, status: value },
      successCallback: () => {
        cb?.(ids);
      }
    })
  );
}

export function overrideClickForPositionHandlerOnInvoice({
  value,
  positions,
  dispatch
}) {
  const appRate = positions?.[0]?.positionData?.defaultRate;
  const ids = positions?.map((pos) => ({
    id: pos?._id,
    isHalfDayManualOverride: value
    // estimateAppliedRate: value
    //   ? appRate + HALF_DAY_INCREMENTED_RATE
    //   : appRate - HALF_DAY_INCREMENTED_RATE,
  }));

  dispatch(
    overridePosiitonClickAction({ payload: { data: { ids }, status: value } })
  );
}

// print submitted estimate
export function getInvoiceRows({
  eventInfo,
  sessions,
  positions,
  contactInfo,
  config,
  type,
  reimAmount
}) {
  let newTerms = {
    halfDay: eventInfo?.terms?.halfDayHours,
    fullDay: eventInfo?.terms?.fullDayHours,
    overTime: eventInfo?.terms?.overTimeHours,
    contractorHourlyRate: eventInfo?.terms?.contractorHourlyRate,
    clientHourlyRate: eventInfo?.terms?.clientHourlyRate,
    clientHalfDayInc: eventInfo?.terms?.clientHalfDayInc,
    contractorHalfDayInc: eventInfo?.terms?.contractorHalfDayInc
  };

  let positionOtAndDt = {};
  Object.entries(positions)?.forEach(([key, value]) => {
    value?.forEach((pos) => {
      const appliedRate = checkValidValue({ value: pos?.estimateAppliedRate })
        ? pos?.estimateAppliedRate
        : pos?.positionData?.defaultRate;
      const { ftHours, otHours, dtHours } = calcEstimateForInvoice(
        getObjForInvoiceCalculation({
          timezone: eventInfo?.eventTimezone,
          pos,
          terms: newTerms,
          appliedRate
        })
      );
      if (!positionOtAndDt[pos?._id]) {
        positionOtAndDt[pos?._id] = {};
      }

      positionOtAndDt[pos?._id]["overTimeEstimate"] =
        parseFloat(otHours || 0) * 1.5 * appliedRate +
        parseFloat(dtHours || 0) * 2 * appliedRate;

      positionOtAndDt[pos?._id]["fullTimeEstimate"] =
        parseFloat(ftHours || 0) * appliedRate;
    });
  });

  let sessionTotalsExcOtDt = {};
  let sessionFullTimeTotal = {};
  sessions?.forEach((session) => {
    let total = 0;
    let excTotal = 0;
    positions?.[session?._id]?.forEach((pos) => {
      total += positionOtAndDt[pos?._id]?.overTimeEstimate || 0;
      excTotal += positionOtAndDt[pos?._id]?.fullTimeEstimate || 0;
    });
    sessionTotalsExcOtDt[session?._id] = excTotal;
    sessionFullTimeTotal[session?._id] = total;
  });

  let mealPenaltyTotal = 0;

  const sessionData = sessions?.map((sItem) => {
    let sessionOTDT = 0;
    return {
      ...sItem,
      subTotal: sessionTotalsExcOtDt?.[sItem?._id]?.toFixed(2).toString(),
      positions: _.chain(
        (positions?.[sItem?._id] || []).map((p) => {
          const breaks = getBreaks(p, false);
          return { ...p, breaks };
        })
      )
        .groupBy((p) => {
          const rate = checkValidValue({ value: p?.estimateAppliedRate })
            ? p?.estimateAppliedRate
            : p?.positionData?.defaultRate;
          const breaks = getBreaks(p, false);
          p.breaks = breaks;
          const {
            overT,
            ftHours: hours,
            otHours,
            dtHours
          } = calcEstimateForInvoice(
            getObjForInvoiceCalculation({
              timezone: eventInfo?.eventTimezone,
              pos: p,
              terms: newTerms,
              appliedRate: rate
            })
          ) || {};
          return [
            p?.positionId,
            dayjs(p?.startDate)?.format("YYYY-MM-DD"),
            overT,
            hours,
            otHours,
            dtHours,
            // `!!` — ver appCalcutions/pdfUtils/pdfObjCreation.ts: null e false são
            // o MESMO estado, mas viram "" e "false" no join("_") e separam shifts
            // idênticos em duas linhas (APCO 26/07, "Stagehand Wed 08/05").
            !!p?.isHalfdayHours,
            p?.isHalfDayManualOverride,
            p?.assignedContractor,
            p?.mealPenaltyHours,
            breaks,
            rate
          ].join("_");
        })
        .map((groupedItems) => {
          sessionOTDT += _.sumBy(
            groupedItems,
            (item) => positionOtAndDt?.[item?._id]?.overTimeEstimate || 0
          );

          const baseItem = groupedItems?.[0];
          const rateHere = checkValidValue({
            value: baseItem?.estimateAppliedRate
          })
            ? baseItem?.estimateAppliedRate
            : baseItem?.positionData?.defaultRate;

          const mp = parseFloat(baseItem?.mealPenaltyHours || 0);
          mealPenaltyTotal += mp * rateHere * 1.5;

          const {
            overT,
            ftHours: hours,
            otHours,
            dtHours
          } = calcEstimateForInvoice(
            getObjForInvoiceCalculation({
              timezone: eventInfo?.eventTimezone,
              pos: baseItem,
              terms: newTerms,
              appliedRate: rateHere
            })
          ) || {};

          return {
            ...baseItem,
            subSection: [hours, overT, otHours, dtHours, mp]
              ?.map((h, idx) => {
                if (!h) return null;
                const rate = getRateThoughHoursIdx(
                  idx,
                  baseItem?.isHalfdayHours
                );
                const applied = rateHere;
                const people = groupedItems?.length || 1;
                const totalHours = idx == 0 ? hours : h; // added this here for new way of showing data

                const totalPositionRate =
                  idx == 0
                    ? getFullTimeEstimate({
                        totalHours: totalHours,
                        rate: rate * applied * people
                      })
                    : h * rate * applied * people;

                return {
                  appliedRate: rate * applied,
                  description: getDescriptionThoughHoursIdxInvoice(
                    idx,
                    baseItem?.isHalfDayManualOverride
                      ? baseItem?.isHalfdayHours
                      : hours + otHours + dtHours >
                            eventInfo?.terms?.halfDayHours + 1 &&
                          baseItem?.isHalfdayHours
                        ? false
                        : baseItem?.isHalfdayHours
                  ),
                  hours: formatNumber(totalHours),
                  people,
                  estimate: formatNumber(totalPositionRate),
                  contractor: isUserRole(
                    USER_ROLES.SUPERADMIN,
                    USER_ROLES.ADMIN
                  )
                    ? baseItem?.contractorName
                    : "",
                  note: isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
                    ? baseItem?.notes
                    : ""
                };
              })
              ?.filter(Boolean)
          };
        })
        .groupBy((item) => {
          return type === "perPosition"
            ? `${dayjs(item?.startDate).format("YYYY-MM-DD")}-${
                item?.positionId
              }`
            : dayjs(item?.startDate).format("YYYY-MM-DD");
        })
        .flatMap((groupedByDate) => {
          const totalEstimate = _.sumBy(groupedByDate, (item) =>
            _.sumBy(item?.subSection, (s) => s?.estimate || 0)
          );
          const fDate = dayjs(groupedByDate[0]?.timeIn).format("YYYY-MM-DD");
          return [
            ...groupedByDate,
            {
              isSubtotal: true,
              estimate: totalEstimate,
              date: fDate,
              startDate: fDate
            }
          ];
        })
        .value(),
      subTotalOTDT: sessionOTDT
    };
  });

  const clientData = {
    date: getUniversalDateTimeFormat({
      dateTime: eventInfo?.date || dayjs().toDate()
    }),
    time: dayjs(eventInfo?.date || new Date()).format("hh:mm A"),
    timezone: eventInfo?.eventTimezone,
    recipient: getRecipient({ eventInfo }),
    event: eventInfo?.eventName,
    email: contactInfo?.email,
    phone: contactInfo?.mobile,
    poNumber: contactInfo?.poNumber,
    invoiceNumber: contactInfo?.invoiceNumber
  };

  let totalOtDt = 0;
  Object.entries(positionOtAndDt)?.forEach(([key, value]) => {
    totalOtDt += parseFloat(value?.overTimeEstimate);
  });

  let sessionTotalsFullTime = 0;
  Object.entries(sessionFullTimeTotal)?.forEach(([key, value]) => {
    sessionTotalsFullTime +=
      parseFloat(value) + parseFloat(sessionTotalsExcOtDt?.[key]);
  });

  const estimate = {
    otdt: parseFloat(totalOtDt).toFixed(2),
    excludingOTDT: parseFloat(sessionTotalsFullTime - totalOtDt).toFixed(2),
    estimateName: config?.estimateName,
    generationTime: dayjs(config?.invoiceGeneratedOn)?.isValid()
      ? getUniversalDateWithTimeFormat({ dateTime: config?.invoiceGeneratedOn })
      : dayjs(config?.invoiceGeneratedOn || new Date())?.format(
          "ddd MM/DD/YYYY [at] hh:mm a"
        ),
    creationTime: config?.invoiceGeneratedOn
  };

  let reimbursementRows = _(reimAmount)
    .flatMap("reimbursements")
    .groupBy(
      (item) => item?.reImbursementCategoryType || item?.reImbursementType
    )
    .map((items, categoryType) => ({
      categoryType,
      amount: _.sumBy(items, "totalApprovedAmount")
    }))
    .value();

  const reimbursementAmount = reimbursementRows?.reduce(
    (acc, r) => acc + r?.amount,
    0
  );

  let taxAmount = parseFloat(
    (parseFloat(eventInfo?.tax?.taxValue) / 100) *
      (parseFloat(estimate?.otdt) +
        parseFloat(estimate?.excludingOTDT) +
        parseFloat(mealPenaltyTotal) +
        parseFloat(reimbursementAmount))
  ).toFixed(2);

  const newTax = {
    name: eventInfo?.tax?.taxName,
    percentage: eventInfo?.tax?.taxValue,
    taxAmount
  };

  const grandTotal =
    parseFloat(taxAmount) +
    parseFloat(estimate?.otdt) +
    parseFloat(estimate?.excludingOTDT) +
    parseFloat(mealPenaltyTotal) +
    parseFloat(reimbursementAmount);

  return {
    sessions: sessionData,
    client: clientData,
    terms: newTerms,
    tax: newTax,
    grandTotal: parseFloat(grandTotal).toFixed(2),
    estimate,
    pdfName: `${eventInfo?.eventName}-Invoice`,
    type,
    reimbursementRows,
    invoiceDepositAmount: contactInfo?.invoiceDepositAmount || 0
  };
}

const isPosActuallyMoreThanHalfDay = (pos, terms) => {
  if (pos?.actualStart || !isTimeTBD(pos?.timeIn)) {
    const { timeDiff } = getTimeDiff(
      pos?.actualStart || pos?.timeIn,
      pos?.actualEnd || pos?.timeIn,
      terms
    );
    return timeDiff > terms?.halfDay + 1;
  } else {
    return pos?.numberOfHours > terms?.halfDay + 1;
  }
};

export const getRemarkRows = ({ pos, eventInfo }) => {
  // need rows with (halfday true ) and which have actual start and end diff more than half day + 1 or override true
  const terms = {
    halfDay: eventInfo?.terms?.halfDayHours,
    fullDay: eventInfo?.terms?.fullDayHours,
    overTime: eventInfo?.terms?.overTimeHours
  };
  return pos?.filter((item) => {
    if (item?.isHalfDayManualOverride) {
      return true;
    }
    if (item?.isHalfdayHours && isPosActuallyMoreThanHalfDay(item, terms)) {
      return true;
    }
    return false;
  });
};

export const getAutoFillPONumber = ({
  sessions,
  updatePONumber,
  estimateId
}) => {
  const poCount = _.countBy(sessions, (s) => s?.poNumber ?? null);
  const filteredCount = _.omit(poCount, [null, "null", undefined]);
  const result =
    _.maxBy(Object.entries(filteredCount), ([, count]) => count)?.[0] ?? "";

  if (result) {
    updatePONumber?.(result, estimateId);
  }

  return result;
};

export const getRecipient = ({ eventInfo }) => {
  const foundC = eventInfo?.foundClients?.find(
    (item) => item?._id === eventInfo?.userId
  );
  return foundC?.companyName || foundC?.firstName + " " + foundC?.lastName;
};

export const getRecipientFromObj = ({ client }) => {
  return client?.companyName || client?.firstName + " " + client?.lastName;
};

export const getConfigEstimates = ({ configs }) => {
  const totalConfig = {};

  configs?.forEach((config) => {
    const positionsMap = {};
    const sessions = config?.estimate?.sessions?.map((ses) => {
      const { positions, ...rest } = ses;
      positionsMap[ses?._id] = [
        ...(ses?.positions?.map((item) => ({
          ...item,
          session: { _id: ses?._id, sessionName: ses?.sessionName }
        })) || [])
      ];
      return rest;
    });
    const eventInfo = {
      tax: config?.estimate?.tax,
      terms: config?.estimate?.terms,
      eventId: config?.estimate?.eventId,
      estimate: config?.estimate?.estimate,
      estimatedProfit: config?.estimate?.estimatedProfit,
      grandTotalEstimate: config?.estimate?.grandTotalEstimate
    };
    const estimateGeneratedAt = config?.estimate?.estimateGeneratedAt;
    const contactInfo = config?.estimate?.contactInformation;
    totalConfig[config?.configId] = {
      eventInfo,
      estimateGeneratedAt,
      contactInfo,
      sessions,
      positions: positionsMap,
      estimateNumber: config?.estimate?.estimateNumber,
      PONumber: config?.estimate?.PONumber,
      estimateId: config?.estimate?._id,
      nonTaxableCharges: config?.estimate?.nonTaxableCharges || []
    };
  });
  return totalConfig;
};

/**
 * data for deposit according to estimates
 */
/**
 * Session ids a submitted estimate actually billed: the frozen
 * `serverCalc.sessions` when the server stored them (since 2026-09-14), else its
 * configuration. A snapshot session carries both `Id` (original session) and
 * `_id`; either may be the one listed. Same rule as the backend
 * (`deposit-source-estimate.ts#billedSessionIdsOf`).
 */
const getEstimateScopeSessionIds = (config) => {
  const billed = config?.serverCalc?.sessions;
  if (Array.isArray(billed)) {
    const ids = billed
      .map((s) => s?.id ?? s?._id ?? s?.Id)
      .filter((id) => id !== undefined && id !== null)
      .map(String);
    if (billed.length === 0 || ids.length > 0) return ids;
  }
  return (config?.configurations?.[0]?.sessionId || []).map(String);
};

/**
 * Submitted estimates keyed by id, in the shape the deposit modal renders. Since
 * 2026-10-20 the deposit is ALWAYS based on one of these snapshots (never on the
 * live shifts), so the rows and totals shown are the estimate's.
 */
export const getConfigForDepositEstimates = ({ configs }) => {
  const totalConfig = {};

  configs?.forEach((config) => {
    const positionsMap = {};
    const scopeIds = getEstimateScopeSessionIds(config);
    const sessions = config?.sessions
      ?.filter((item) =>
        [item?._id, item?.Id].some(
          (id) => id !== undefined && id !== null && scopeIds.includes(String(id))
        )
      )
      ?.map((ses) => {
        const { positions, ...rest } = ses;
        positionsMap[ses?._id] = [
          ...(ses?.positions?.map((item) => ({
            ...item,
            session: { _id: ses?._id, sessionName: ses?.sessionName }
          })) || [])
        ];
        return rest;
      });
    const eventInfo = {
      tax: config?.tax,
      terms: config?.terms,
      eventId: config?.eventId,
      estimate: config?.estimate,
      estimatedProfit: config?.estimatedProfit,
      grandTotalEstimate: config?.grandTotalEstimate
    };
    const estimateGeneratedAt = config?.estimateGeneratedAt;
    const contactInfo = config?.contactInformation;
    totalConfig[config?._id] = {
      estimateId: config?._id,
      eventInfo,
      estimateGeneratedAt,
      contactInfo,
      sessions,
      positions: positionsMap,
      estimateNumber: config?.estimateNumber,
      PONumber: config?.PONumber,
      nonTaxableCharges: config?.nonTaxableCharges || []
    };
  });
  return totalConfig;
};

export const getConfigInvoice = ({ configs }) => {
  const totalConfig = {};

  configs?.forEach((config) => {
    const positionsMap = {};
    const sessions = config?.invoice?.sessions?.map((ses) => {
      const { positions, ...rest } = ses;
      positionsMap[ses?._id] = [
        ...(ses?.positions?.map((item) => ({
          ...item,
          session: { _id: ses?._id, sessionName: ses?.sessionName }
        })) || [])
      ];
      return rest;
    });
    const eventInfo = {
      tax: config?.invoice?.tax,
      terms: config?.invoice?.terms,
      eventId: config?.invoice?.eventId,
      estimate: config?.invoice?.estimate,
      estimatedProfit: config?.invoice?.estimatedProfit,
      grandTotalEstimate: config?.invoice?.grandTotalEstimate
    };
    const estimateGeneratedAt = config?.invoice?.estimateGeneratedAt;
    const contactInfo = config?.invoice?.contactInformation;
    totalConfig[config?.configId] = {
      eventInfo,
      estimateGeneratedAt,
      contactInfo,
      sessions,
      positions: positionsMap,
      invoiceNumber: config?.invoice?.inVoiceNumber,
      PONumber: config?.invoice?.PONumber,
      invoiceGeneratedOn: config?.invoice?.invoiceGeneratedAt,
      invoiceDate: config?.invoice?.invoiceDate,
      invoiceTimeZone: config?.invoice?.invoiceTimeZone,
      paymentDueInDays: config?.invoice?.paymentDueInDays,
      paymentDueDate: config?.invoice?.paymentDueDate,
      reimAmount: config?.invoice?.reimbursementCategoryTotals,
      invoiceDepositAmount: config?.invoice?.invoiceDepositAmount || 0,
      reimbursements: config?.invoice?.reimbursements || [],
      deductions: config?.invoice?.deductions || [],
      nonTaxableCharges: config?.invoice?.nonTaxableCharges || [],
      // Finance request 2026-09-10 (items 2, 6, 9): frozen with the invoice.
      adjustments: config?.invoice?.adjustments || null,
      memo: config?.invoice?.memo || "",
      // Finance item 8: the lines as edited on the invoice.
      lineEdits: config?.invoice?.lineEdits || null,
      expenseBreakdown: config?.invoice?.expenseBreakdown,
      invoiceId: config?.invoice?._id
    };
  });
  return totalConfig;
};

export const getShareableInvoiceData = ({ data }) => {
  const positionsMap = {};
  const sessions = data?.sessions?.map((ses) => {
    const { positions, ...rest } = ses;
    positionsMap[ses?._id] = [
      ...(ses?.positions?.map((item) => ({
        ...item,
        session: { _id: ses?._id, sessionName: ses?.sessionName }
      })) || [])
    ];
    return rest;
  });
  const eventInfo = {
    tax: data?.tax,
    terms: data?.terms,
    eventId: data?.eventId,
    estimate: data?.estimate,
    estimatedProfit: data?.estimatedProfit,
    grandTotalEstimate: data?.grandTotalEstimate
  };
  const estimateGeneratedAt = data?.estimateGeneratedAt;
  const contactInfo = data?.contactInformation;
  return {
    eventInfo,
    estimateGeneratedAt,
    contactInfo,
    sessions,
    positions: positionsMap,
    invoiceNumber: data?.inVoiceNumber,
    PONumber: data?.PONumber,
    invoiceGeneratedOn: data?.invoiceGeneratedAt,
    invoiceDate: data?.invoiceDate,
    invoiceTimeZone: data?.invoiceTimeZone,
    paymentDueInDays: data?.paymentDueInDays,
    paymentDueDate: data?.paymentDueDate,
    reimAmount: data?.reimbursementCategoryTotals
  };
};

/**
 * get start and end time if added or get tbd of hours for either estimate and invoice
 */
export const getStartAndEndTime = ({ row, timezone, isEstimate }) => {
  const timeInField = isEstimate ? "timeIn" : "actualStart";
  const timeOutField = isEstimate ? "timeOut" : "actualEnd";
  if (
    isTimeTBD(row?.[timeInField] || row?.timeIn) ||
    isTimeTBD(row?.[timeOutField] || row?.timeOut)
  ) {
    return `TBD (${row?.numberOfHours} ${
      row?.numberOfHours > 1 ? "Hours" : "Hour"
    })`;
  } else {
    const startTime = formatAMPM(
      convertFromUTCToGivenTimezone({
        dateStr: row?.[timeInField] || row?.timeIn,
        timezone: timezone
      })
    );
    const endTime = formatAMPM(
      convertFromUTCToGivenTimezone({
        dateStr: row?.[timeOutField] || row?.timeOut,
        timezone: timezone
      })
    );
    return `${startTime} - ${endTime}`;
  }
};

/**
 * get history dropdown of estimate
 */
export const getEstimateHistoryforDropdown = ({ configs }) => {
  return configs?.map((item) => {
    // `estimateNumber` present = estimate actually submitted/generated. Drafts in
    // `submittedestimates` come in without a number (dropdown shows "—") and the
    // Deposit PDF backend can't resolve the lookup → 404 "Estimate not found". `isSubmitted`
    // lets the front block printing of those; uses the SAME condition as `name`.
    const hasEstimateNumber =
      item?.estimateNumber != null && item?.estimateNumber !== "";
    return {
      value: item?._id,
      // Guards against `${undefined}` → the literal string "undefined" in the
      // dropdown when the estimate has no number set. Shows a placeholder instead.
      name: hasEstimateNumber ? `${item?.estimateNumber}` : "—",
      isSubmitted: hasEstimateNumber,
      status: getCurrentStatusOfSubmittedEstimate(item),
      configurationId: item?.configurations?.[0]?.id
    };
  });
};

/**
 * update positions terms according to event hourly rate toggle
 */
export const updatePositionTermsOnEventClick = ({
  newTerms,
  positions,
  dispatch,
  eventId,
  eventTerms,
  ignoreGlobal = false
}) => {
  const positionIds = [];
  const positionList = {};
  let allPos = [];
  Object.keys(positions)?.forEach((sessionId) => {
    positions?.[sessionId]?.forEach((pos) => {
      if (
        (!isUndefined(pos?.positionTerms) &&
          getShortTermsString(pos, {
            eventTerms
          })?.toLowerCase() == "global") ||
        ignoreGlobal
      ) {
        const positionTerms = {
          ...pos?.positionTerms,
          ...newTerms,
          clientHalfDayInc: pos?.isHalfdayHours
            ? isUndefined(newTerms?.clientHalfDayInc)
              ? pos?.positionTerms?.clientHalfDayInc
              : newTerms?.clientHalfDayInc
            : false,
          contractorHalfDayInc: pos?.isHalfdayHours
            ? isUndefined(newTerms?.contractorHalfDayInc)
              ? pos?.positionTerms?.contractorHalfDayInc
              : newTerms?.contractorHalfDayInc
            : false,
          halfDay: newTerms?.halfDayHours,
          fullDay: newTerms?.fullDayHours,
          overTime: newTerms?.overTimeHours,
          clientHourlyRate: isUndefined(newTerms?.clientHourlyRate)
            ? pos?.positionTerms?.clientHourlyRate || false
            : newTerms?.clientHourlyRate,
          contractorHourlyRate: isUndefined(newTerms?.contractorHourlyRate)
            ? pos?.positionTerms?.contractorHourlyRate || false
            : newTerms?.contractorHourlyRate
        };
        positionIds?.push({
          id: pos?._id,
          timeIn: pos?.timeIn,
          timeOut: pos?.timeOut,
          numberOfHours: pos?.numberOfHours,
          positionTerms,
          updatedContractorRate: pos?.updatedContractorRate,
          positionData: {
            contractorRate: pos?.positionData?.contractorRate
          },
          session: {
            _id: pos?.session?._id
          }
        });
        positionList[pos?._id] = positionTerms;
      }

      // if ca rate is enabled
      if (eventTerms?.californiaContractorPO_SOW) {
        allPos?.push(pos);
      }
    });
  });
  dispatch(
    postPositionTermsAction({
      payload: {
        params: { eventId },
        data: {
          positionIds
        },
        positions: positionList
      }
    })
  );

  // check and update if necessary
  const finalList = [
    ...allPos,
    ...(positionIds?.map((item) => ({ ...item, _id: item?.id })) || [])
  ];
  checkAndUpdateContractorCARateIfNecessary({
    eventTerms: { ...eventTerms, ...newTerms },
    rows: _?.uniqBy(_?.reverse(finalList), "_id")?.reverse(),
    eventId,
    dispatch
  });
};

/**
 * convert position terms to global terms term
 */
export const convertPositionTerms = ({ position }) => ({
  halfDay: !isUndefined(position?.positionTerms?.halfDayHours)
    ? position?.positionTerms?.halfDayHours
    : 0,
  fullDay: !isUndefined(position?.positionTerms?.fullDayHours)
    ? position?.positionTerms?.fullDayHours
    : 0,
  overTime: !isUndefined(position?.positionTerms?.overTimeHours)
    ? position?.positionTerms?.overTimeHours
    : 0,
  contractorHourlyRate: !isUndefined(
    position?.positionTerms?.contractorHourlyRate
  )
    ? position?.positionTerms?.contractorHourlyRate
    : false,
  clientHourlyRate: !isUndefined(position?.positionTerms?.clientHourlyRate)
    ? position?.positionTerms?.clientHourlyRate
    : false
});

/**
 * get final terms for position
 */
export const getFinalTerms = ({ position, eventTerms, isClient = true }) => {
  if (
    (isClient && position?.positionTerms?.termsForClient) ||
    (!isClient && position?.positionTerms?.termsForContractor)
  ) {
    return {
      halfDay: !isUndefined(position?.positionTerms?.halfDayHours)
        ? position?.positionTerms?.halfDayHours
        : eventTerms?.halfDayHours || eventTerms?.halfDay,
      fullDay: !isUndefined(position?.positionTerms?.fullDayHours)
        ? position?.positionTerms?.fullDayHours
        : eventTerms?.fullDayHours || eventTerms?.fullDay,
      overTime: !isUndefined(position?.positionTerms?.overTimeHours)
        ? position?.positionTerms?.overTimeHours
        : eventTerms?.overTimeHours || eventTerms?.overTime,
      contractorHourlyRate: !isUndefined(
        position?.positionTerms?.contractorHourlyRate
      )
        ? position?.positionTerms?.contractorHourlyRate
        : eventTerms?.contractorHourlyRate,
      clientHourlyRate: !isUndefined(position?.positionTerms?.clientHourlyRate)
        ? position?.positionTerms?.clientHourlyRate
        : eventTerms?.clientHourlyRate,
      clientHalfDayInc: !isUndefined(position?.positionTerms?.clientHalfDayInc)
        ? position?.positionTerms?.clientHalfDayInc
        : eventTerms?.clientHalfDayInc,
      contractorHalfDayInc: !isUndefined(
        position?.positionTerms?.contractorHalfDayInc
      )
        ? position?.positionTerms?.contractorHalfDayInc
        : eventTerms?.contractorHalfDayInc
    };
  } else {
    return {
      halfDay: eventTerms?.halfDayHours || eventTerms?.halfDay,
      fullDay: eventTerms?.fullDayHours || eventTerms?.fullDay,
      overTime: eventTerms?.overTimeHours || eventTerms?.overTime,
      contractorHourlyRate: eventTerms?.contractorHourlyRate,
      clientHourlyRate: eventTerms?.clientHourlyRate,
      clientHalfDayInc: eventTerms?.clientHalfDayInc,
      contractorHalfDayInc: eventTerms?.contractorHalfDayInc
    };
  }
};

/**
 * get object for estimate calculation
 * @param {Object} options - The options for estimate calculation.
 * @param {string} options.timezone - The timezone of the event.
 * @param {Object} options.pos - The position object, typically including associated terms.
 * @param {boolean} options.addHalfDay - Whether to include a half-day in the calculation.
 * @param {Object} options.terms - The terms of the event (e.g., dates, duration).
 * @param {number|string} options.appliedRate - The applied rate for the position (hourly or flat).
 * @param {boolean} options.hourlyRate - Whether to calculate based on an hourly rate.
 * @param {boolean} options.isClient - Whether the calculation is for a client.
 *
 * @returns {Object} The object containing calculation data for the estimate.
 */
// export const getObjForEstimateCalculation = ({
//   timezone,
//   pos,
//   addHalfDay = true,
//   terms,
//   appliedRate,
//   isClient = true,
// }) => {
//   let newTerms = getFinalTerms({ eventTerms: terms, position: pos, isClient });
//
//   const halfDayKey = isClient ? "clientHalfDayInc" : "contractorHalfDayInc";
//   const hourlyRateKey = isClient ? "clientHourlyRate" : "contractorHourlyRate";
//
//   const halfDayResult =
//     addHalfDay && pos?.isHalfdayHours
//       ? isUndefined(pos?.positionTerms?.[halfDayKey])
//         ? terms?.[halfDayKey]
//         : pos?.positionTerms?.[halfDayKey]
//       : false;
//
//   const hourlyRateResult = isUndefined(pos?.positionTerms?.[hourlyRateKey])
//     ? terms?.[hourlyRateKey]
//     : pos?.positionTerms?.[hourlyRateKey];
//
//   return {
//     terms: newTerms,
//     appliedRate,
//     data: {
//       start: pos?.timeIn,
//       end: pos?.timeOut,
//       timezone,
//       numberOfHours: pos?.numberOfHours,
//     },
//     breaks: getBreaksEstimate(pos, true),
//     isHalfDay: halfDayResult,
//     isHourlyRate: hourlyRateResult,
//   };
// };

/**
 * function get get positoin terms of all positions
 */
export const getAllPositionTerms = ({ positions }) => {
  let positionObj = {};
  Object.keys(positions)?.forEach((ses) => {
    positions?.[ses]?.forEach((pos) => {
      if (isUndefined(pos?.positionTerms)) positionObj[pos?._id] = null;
      else positionObj[pos?._id] = pos?.positionTerms;
    });
  });
};

/**
 * get object for PO calculation
 * @param {Object} options - The options for estimate calculation.
 * @param {string} options.timezone - The timezone of the event.
 * @param {Object} options.pos - The position object, typically including associated terms.
 * @param {boolean} options.addHalfDay - Whether to include a half-day in the calculation.
 * @param {Object} options.terms - The terms of the event (e.g., dates, duration).
 * @param {number|string} options.appliedRate - The applied rate for the position (hourly or flat).
 * @param {boolean} options.hourlyRate - Whether to calculate based on an hourly rate.
 * @param {boolean} options.isClient - Whether the calculation is for a client.
 *
 * @returns {Object} The object containing calculation data for the estimate.
 */
export const getObjForPOCalculation = ({
  timezone,
  pos,
  addHalfDay = true,
  terms,
  appliedRate,
  isClient = true
}) => {
  let newTerms = getFinalTerms({ eventTerms: terms, position: pos, isClient });

  const halfDayKey = isClient ? "clientHalfDayInc" : "contractorHalfDayInc";
  const hourlyRateKey = isClient ? "clientHourlyRate" : "contractorHourlyRate";

  const halfDayResult =
    addHalfDay && pos?.isHalfdayHours
      ? isUndefined(pos?.positionTerms?.[halfDayKey])
        ? terms?.[halfDayKey]
        : pos?.positionTerms?.[halfDayKey]
      : false;

  const hourlyRateResult = isUndefined(pos?.positionTerms?.[hourlyRateKey])
    ? terms?.[hourlyRateKey]
    : pos?.positionTerms?.[hourlyRateKey];

  return {
    terms: newTerms,
    appliedRate,
    data: {
      start: pos?.actualStart || pos?.timeIn,
      end: pos?.actualEnd || pos?.timeOut,
      timezone,
      numberOfHours: pos?.numberOfHours
    },
    breaks: getBreaks(pos),
    isHalfDay: halfDayResult,
    isHourlyRate: hourlyRateResult,
    givenOtAndDt: {
      givenOt: pos?.oT,
      givenDt: pos?.dT,
      givenMOt: pos?.actualMidnightOT
    }
  };
};

/**
 * get object for Invoice calculation
 * @param {Object} options - The options for estimate calculation.
 * @param {string} options.timezone - The timezone of the event.
 * @param {Object} options.pos - The position object, typically including associated terms.
 * @param {boolean} options.addHalfDay - Whether to include a half-day in the calculation.
 * @param {Object} options.terms - The terms of the event (e.g., dates, duration).
 * @param {number|string} options.appliedRate - The applied rate for the position (hourly or flat).
 * @param {boolean} options.hourlyRate - Whether to calculate based on an hourly rate.
 * @param {boolean} options.isClient - Whether the calculation is for a client.
 *
 * @returns {Object} The object containing calculation data for the estimate.
 */
export const getObjForInvoiceCalculation = ({
  timezone,
  pos,
  addHalfDay = true,
  terms,
  appliedRate,
  isClient = true
}) => {
  let newTerms = getFinalTerms({ eventTerms: terms, position: pos, isClient });

  const halfDayKey = isClient ? "clientHalfDayInc" : "contractorHalfDayInc";
  const hourlyRateKey = isClient ? "clientHourlyRate" : "contractorHourlyRate";

  const halfDayResult =
    addHalfDay && pos?.isHalfdayHours
      ? isUndefined(pos?.positionTerms?.[halfDayKey])
        ? terms?.[halfDayKey]
        : pos?.positionTerms?.[halfDayKey]
      : false;

  const hourlyRateResult = isUndefined(pos?.positionTerms?.[hourlyRateKey])
    ? terms?.[hourlyRateKey]
    : pos?.positionTerms?.[hourlyRateKey];

  return {
    terms: newTerms,
    appliedRate,
    data: {
      start: pos?.actualStart || pos?.timeIn,
      end: pos?.actualEnd || pos?.timeOut,
      timezone,
      numberOfHours: pos?.numberOfHours
    },
    breaks: getBreaks(pos),
    isHalfDay: halfDayResult,
    isHourlyRate: hourlyRateResult,
    isHDOverride: halfDayResult ? pos?.isHalfDayManualOverride : false,
    givenOtAndDt: {
      givenOt: pos?.oT,
      givenDt: pos?.dT,
      givenMOt: pos?.actualMidnightOT
    }
  };
};

/**
 * demo csv
 */

/**
 * csv list generator
 *
 * @param {Object} invoiceData
 */
export const generateAccountingCSVString = (invoiceData) => {
  // const invoiceData = invoiceDataForExport;
  // Helper to format dates to MM/DD/YYYY. Handles null/invalid dates gracefully.
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    } catch (e) {
      return ""; // Return empty string if date is invalid
    }
  };

  // Helper function to escape cells (no changes needed here)
  const escapeCsvCell = (cell) => {
    if (cell == null) return "";
    const strCell = String(cell);
    if (
      strCell.includes(",") ||
      strCell.includes('"') ||
      strCell.includes("\n")
    ) {
      const escapedCell = strCell.replace(/"/g, '""');
      return `"${escapedCell}"`;
    }
    return strCell;
  };

  // --- 1. Define CSV Headers ---
  const headers = [
    "Invoice Number",
    "Client",
    "Show Name",
    "Client PO #",
    "Invoice Date",
    "Due Date",
    "Terms",
    "Item",
    "Description",
    "Quantity",
    "Rate",
    "Amount"
  ];

  // --- 2. Map each line item to a full CSV row ---
  const dataRows = invoiceData.lineItems.map((item) => {
    // Construct the special "Description" field
    const description = `${item?.contractorName || "N/A"} – ${formatDate(
      item?.serviceDate
    )}`;

    // Each row contains the repeated header info + the specific line item info
    const row = [
      invoiceData?.invoiceNumber,
      invoiceData?.clientName,
      invoiceData?.showName,
      invoiceData?.clientPO || "", // Use empty string if PO is null/undefined
      formatDate(invoiceData?.invoiceDate),
      formatDate(invoiceData?.dueDate),
      invoiceData?.terms,
      item?.item,
      description,
      item?.quantity,
      item?.rate ?? "00.00",
      item?.amount ?? "00.00"
    ];
    return row;
  });

  // --- 3. Combine headers and data rows ---
  const allRows = [headers, ...dataRows];

  // --- 4. Convert to CSV string and return ---
  return allRows?.map((row) => row?.map(escapeCsvCell).join(",")).join("\n");
};

/**
 * download csv from invoices history
 *
 */
export const downloadCSVInInvoiceHistory = ({
  eventInfo,
  sessions,
  positions,
  contactInfo,
  config,
  type,
  reimAmount
}) => {
  const data = getInvoiceRows({
    eventInfo,
    sessions,
    positions,
    contactInfo,
    config,
    type,
    reimAmount
  });
  const requiredString = {
    invoiceNumber: data?.client?.invoiceNumber,
    clientName: data?.client?.recipient,
    showName: data?.client?.event,
    clientPO: data?.client?.poNumber,
    invoiceDate: data?.estimate?.creationTime,
    dueDate: "",
    terms: "Due on receipt",
    lineItems: []
  };

  data?.sessions?.forEach((ses) => {
    ses?.positions?.forEach((pos) => {
      pos?.subSection
        ?.filter((i) => !i?.subTotal)
        ?.forEach((item) => {
          requiredString?.lineItems?.push({
            item: `${pos?.positionName || ""}${
              item?.description ? ` (${item.description})` : ""
            }`,
            contractorName: pos?.contractorName,
            serviceDate: dayjs(dayjs(pos?.startDate)?.toDate())?.format(
              "MM-DD-YYYY"
            ),
            quantity: item?.people * item?.hours,
            rate: `$${item?.appliedRate}`,
            amount: `$${item?.estimate?.toFixed(2)}`
          });
        });
    });
  });

  requiredString.lineItems = [
    ...(requiredString?.lineItems || []),
    ...(data?.reimbursementRows?.map((r) => ({
      item: `Reimbursement ${r?.categoryType}`,
      contractorName: "",
      serviceDate: "",
      quantity: "",
      rate: "",
      amount: `$${parseFloat(r?.amount)?.toFixed(2)}`
    })) || [])
  ];
  const str = generateAccountingCSVString(requiredString);
  downloadCSV({
    csvString: str,
    filename: getSanitizedFileName({
      name: `${data?.client?.event} ${data?.client?.invoiceNumber}`
    })
  });
};

/**
 * get object of terms
 */
const getObjectOfTerms = ({ terms }) => {
  return {
    halfDayHours: terms?.halfDayHours || terms?.halfDay || 5,
    fullDayHours: terms?.fullDayHours || terms?.fullDay || 10,
    overTimeHours: terms?.overTimeHours || terms?.overTime || 2,
    contractorHourlyRate: terms?.contractorHourlyRate || false,
    clientHourlyRate: terms?.clientHourlyRate || false,
    clientHalfDayInc: terms?.clientHalfDayInc || false,
    contractorHalfDayInc: terms?.contractorHalfDayInc || false,
    termsForClient: terms?.termsForClient || false,
    termsForContractor: terms?.termsForContractor || false
  };
};

/**
 * get merged event terms
 */
export const getMergedEventTerms = ({ oldTerm, newTerm }) => {
  return {
    ...getObjectOfTerms({ terms: oldTerm }),
    ...getObjectOfTerms({ terms: newTerm })
  };
};

/**
 * get positon terms string
 */
export function getShortTermsString(
  pos = {},
  options = {
    showHD: true,
    disableClient: false,
    disableContractor: false,
    eventTerms: {}
  }
) {
  // if (pos?.positionName == "AV Utility") {
  //   debugger;
  // }
  const {
    showHD = true,
    disableClient = false,
    disableContractor = false,
    eventTerms = {}
  } = options;

  // Get a safe copy of eventTerms with default values for comparison
  const correctEventTerms = {
    ...getObjectOfTerms({ terms: eventTerms }),
    termsForClient: false,
    termsForContractor: false
  };

  let positionTerms = {
    halfDayHours: !isUndefined(pos?.positionTerms?.halfDayHours)
      ? pos?.positionTerms?.halfDayHours
      : correctEventTerms?.halfDayHours,
    fullDayHours: !isUndefined(pos?.positionTerms?.fullDayHours)
      ? pos?.positionTerms?.fullDayHours
      : correctEventTerms?.fullDayHours,
    overTimeHours: !isUndefined(pos?.positionTerms?.overTimeHours)
      ? pos?.positionTerms?.overTimeHours
      : correctEventTerms?.overTimeHours,
    termsForClient: pos?.positionTerms?.termsForClient || false,
    termsForContractor: pos?.positionTerms?.termsForContractor || false,
    contractorHourlyRate: !isUndefined(pos?.positionTerms?.contractorHourlyRate)
      ? pos?.positionTerms?.contractorHourlyRate
      : correctEventTerms?.contractorHourlyRate,
    clientHourlyRate: !isUndefined(pos?.positionTerms?.clientHourlyRate)
      ? pos?.positionTerms?.clientHourlyRate
      : correctEventTerms?.clientHourlyRate,
    contractorHalfDayInc: pos?.isHalfdayHours
      ? pos?.positionTerms?.contractorHalfDayInc || false
      : false,
    clientHalfDayInc: pos?.isHalfdayHours
      ? pos?.positionTerms?.clientHalfDayInc || false
      : false
  };

  // NOTE: disable position terms for contractor if eventterm's californiaContractorPO_SOW is enabled
  positionTerms.termsForContractor = eventTerms?.californiaContractorPO_SOW
    ? false
    : positionTerms.termsForContractor;

  // Determine if termsForClient and termsForContractor are disabled
  const termsForClient = !disableClient && !!positionTerms?.termsForClient;
  const termsForContractor =
    !disableContractor && !!positionTerms?.termsForContractor;

  // If both client and contractor terms are disabled, exclude time-related terms from global comparison
  const keysToCompare = Object.keys(correctEventTerms).filter((key) => {
    // If either client or contractor terms are enabled, include time-related keys in comparison
    if (termsForClient || termsForContractor) {
      return true;
    }
    // If both client and contractor terms are disabled, exclude time-related keys
    return !["halfDayHours", "fullDayHours", "overTimeHours"].includes(key);
  });

  // Safely check if eventTerms match all the keys in terms (global match)
  let isGlobal = keysToCompare.every(
    (key) => positionTerms[key] === correctEventTerms[key]
  );

  // if (pos?.positionName == "interior designer") {
  // debugger;
  // }

  let tD = 0;
  if (
    (positionTerms?.clientHalfDayInc ||
      positionTerms?.contractorHalfDayInc ||
      correctEventTerms?.clientHalfDayInc ||
      correctEventTerms?.contractorHalfDayInc) &&
    showHD
  ) {
    const { timeDiff } = !isTimeTBD(pos?.timeIn)
      ? getTimeDiff(pos?.timeIn, pos?.timeOut, {
          halfDay: correctEventTerms?.halfDayHours,
          fullDay: correctEventTerms?.fullDayHours,
          overTime: correctEventTerms?.overTimeHours
        })
      : { timeDiff: pos?.numberOfHours || 0 };
    tD = timeDiff;

    const condition1 =
      tD > correctEventTerms?.halfDayHours + 1 && pos?.isHalfdayHours;
    const condition2 =
      tD <= correctEventTerms?.halfDayHours + 1 && !pos?.isHalfdayHours;
    const condition3 =
      positionTerms?.clientHalfDayInc != correctEventTerms?.clientHalfDayInc ||
      positionTerms?.contractorHalfDayInc !=
        correctEventTerms?.contractorHalfDayInc;

    if (condition1 || condition2 || condition3) {
      isGlobal = false;
    }
  }

  // If global match, return "Global"
  if (isGlobal) {
    return "Global";
  }

  // Time values (only calculate if either client or contractor is enabled)
  let timeTermsPart = "";
  if (termsForClient || termsForContractor) {
    const timeTerms = [
      positionTerms?.halfDayHours,
      positionTerms?.fullDayHours,
      positionTerms?.overTimeHours
    ].filter((v) => v !== undefined && v !== null);

    if (timeTerms.length) {
      const userLabel =
        termsForClient && termsForContractor
          ? ""
          : termsForClient
            ? " - Cl"
            : " - Ct";
      timeTermsPart = `T(${timeTerms.join(", ")})${userLabel}`;
    }
  }

  // Hourly Rate (HR)
  const hrUsers = [];
  if (
    !disableClient &&
    positionTerms?.clientHourlyRate &&
    positionTerms?.clientHourlyRate != correctEventTerms?.clientHourlyRate
  )
    hrUsers.push("Cl");
  if (
    !disableContractor &&
    positionTerms?.contractorHourlyRate &&
    positionTerms?.contractorHourlyRate !=
      correctEventTerms?.contractorHourlyRate
  )
    hrUsers.push("Ct");

  let hrPart = "";
  if (hrUsers.length === 1) {
    hrPart = `HR - ${hrUsers[0]}`;
  } else if (hrUsers.length === 2) {
    hrPart = `HR`;
  }

  // Daily rate (DR)
  const drUsers = [];
  if (
    !disableClient &&
    !positionTerms?.clientHourlyRate &&
    correctEventTerms?.clientHourlyRate &&
    !isUndefined(positionTerms?.clientHourlyRate)
  )
    drUsers.push("Cl");
  if (
    !disableContractor &&
    !positionTerms?.contractorHourlyRate &&
    correctEventTerms?.contractorHourlyRate &&
    !isUndefined(positionTerms?.contractorHourlyRate)
  )
    drUsers.push("Ct");

  let drPart = "";
  if (drUsers.length === 1) {
    drPart = `DR - ${drUsers[0]}`;
  } else if (drUsers.length === 2) {
    drPart = `DR`;
  }

  const halfDayHourForEvent = correctEventTerms?.halfDayHours + 1;

  const conditionForHDClient =
    tD > halfDayHourForEvent ||
    positionTerms?.clientHalfDayInc != correctEventTerms?.clientHalfDayInc ||
    tD <= halfDayHourForEvent;
  const conditionForHDContractor =
    tD > halfDayHourForEvent ||
    positionTerms?.contractorHalfDayInc !=
      correctEventTerms?.contractorHalfDayInc ||
    tD <= halfDayHourForEvent;

  // Half Day (HD) - optional
  let hdPart = "";
  if (showHD) {
    const hdUsers = [];
    if (
      !disableClient &&
      positionTerms?.clientHalfDayInc &&
      conditionForHDClient
    )
      hdUsers.push("Cl");
    if (
      !disableContractor &&
      positionTerms?.contractorHalfDayInc &&
      conditionForHDContractor
    )
      hdUsers.push("Ct");

    if (hdUsers.length === 1) {
      hdPart = `HD - ${hdUsers[0]}`;
    } else if (hdUsers.length === 2) {
      hdPart = `HD`;
    }
  }

  // full Day rate (FD)
  const fdUsers = [];
  if (
    !disableClient &&
    !positionTerms?.clientHalfDayInc &&
    !isUndefined(positionTerms?.clientHalfDayInc) &&
    tD <= halfDayHourForEvent
  )
    fdUsers.push("Cl");
  if (
    !disableContractor &&
    !positionTerms?.contractorHalfDayInc &&
    !isUndefined(positionTerms?.contractorHalfDayInc) &&
    tD <= halfDayHourForEvent
  )
    fdUsers.push("Ct");

  let fdPart = "";
  if (showHD) {
    if (fdUsers.length === 1) {
      fdPart = `FD - ${fdUsers[0]}`;
    } else if (fdUsers.length === 2) {
      fdPart = `FD`;
    }
  }

  const allParts = [hdPart, drPart, timeTermsPart, hrPart, fdPart].filter(
    Boolean
  );

  if (disableClient || disableContractor) {
    return allParts?.length
      ? allParts?.map((i) => i?.split(" ")?.[0])?.join(", ")
      : "Global";
  }

  return allParts.length ? allParts.join(", ") : "Global";
}

/**
 * positin terms list
 */
export const posTermsHelp = (forClient = false) => {
  if (forClient) {
    return [
      { title: "T", text: "Terms" },
      { title: "HD", text: "Half Day" },
      { title: "HR", text: "Hourly Rate" },
      { title: "DR", text: "Daily Rate" },
      { title: "FD", text: "Full Day" }
      // { title: "Ct", text: "For Contractor" },
      // { title: "Cl", text: "For Client" },
    ];
  } else {
    return [
      { title: "T", text: "Terms" },
      { title: "HD", text: "Half Day" },
      { title: "HR", text: "Hourly Rate" },
      { title: "DR", text: "Daily Rate" },
      { title: "FD", text: "Full Day" },
      { title: "Ct", text: "For Contractor" },
      { title: "Cl", text: "For Client" }
    ];
  }
};

/**
 * get client rate highlight on estimate
 * @param {Object} row
 * @returns color | null
 */
export const clientRateHighlight = (row) => {
  if (row?.isClientDefaultRate) {
    return `${getCssVariableHandler({
      variableName: "--ratelist-not-found-color"
    })} !important`;
  }
  if (row?.isClientRateChanged) {
    return `${getCssVariableHandler({ variableName: "--primary-pink-hex" })} !important`;
  }
  return null;
};

/**
 * get contractor rate highlight on estimate
 * @param {Object} row
 * @returns color | null
 */
export const contractorRateHighlight = (row) => {
  if (row?.isContractorDefaultRate) {
    return `${getCssVariableHandler({
      variableName: "--ratelist-not-found-color"
    })} !important`;
  }
  if (row?.isContractorRateChanged) {
    return `${getCssVariableHandler({ variableName: "--primary-pink-hex" })} !important`;
  }
  return null;
};

/**
 * check mark hover message for both client and contractor
 * @param {Object} row
 * @returns string | null
 */
export const checkMarkMessage = (row) => {
  let base = "This cell is highlighted because ";
  // rates are not from selected rate list takes precedence
  if (row?.isClientDefaultRate && row?.isContractorDefaultRate) {
    return (
      base +
      "client and contractor's default rate for this position were not found on the selected rate list."
    );
  }
  if (row?.isClientDefaultRate) {
    return (
      base +
      "client's default rate for this position was not found on the selected rate list."
    );
  }
  if (row?.isContractorDefaultRate) {
    return (
      base +
      "contractor's default rate for this position was not found on the selected rate list."
    );
  }
  // client and contractor rate differnet between client and contractor default vs applied rate
  if (row?.isClientRateChanged && row?.isContractorRateChanged) {
    return (
      base +
      "there is a difference between both client and contractor's default rates and the currently applied rates in this list."
    );
  }
  if (row?.isClientRateChanged) {
    return (
      base +
      "there is a difference between the client's default rate and the currently applied rate in this list."
    );
  }
  if (row?.isContractorRateChanged) {
    return (
      base +
      "there is a difference between the contractor's default rate and the currently applied rate in this list."
    );
  }
  return null;
};

/**
 * funciton to sent sanitized terms of event (only for the estimate tabs)
 */
export const getSanitizedTerms = (termsData) => {
  return {
    halfDay: termsData?.halfDayHours || 5,
    fullDay: termsData?.fullDayHours || 10,
    overTime: termsData?.overTimeHours || 2,
    contractorHourlyRate: termsData?.contractorHourlyRate || false,
    clientHourlyRate: termsData?.clientHourlyRate || false,
    clientHalfDayInc: termsData?.clientHalfDayInc || false,
    contractorHalfDayInc: termsData?.contractorHalfDayInc || false,
    californiaContractorPO_SOW: termsData?.californiaContractorPO_SOW || false
  };
};
